import React, { forwardRef } from 'react';

import PropTypes from 'prop-types';

const Element = forwardRef(({ data, className, children, handleClick }, ref) =>
  data.link ? (
    <a
      ref={ref}
      href={data.link}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {children}
    </a>
  ) : (
    <div ref={ref} className={className}>
      {children}
    </div>
  )
);

Element.displayName = 'Element';

Element.propTypes = {
  data: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default Element;
